export const init = () => {

  // TRACKER 'BASKET'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.funnel.global);

  // - breadcrumbClick
  const breadcrumbClick = new AnalyticsClickEvent('breadcrumbClick', tracker.defaultEvent());
  breadcrumbClick.domElement = 'a.dkt-checkout-breadcrumbs__item';
  breadcrumbClick.options.action = 'BreadcrumbClick';
  breadcrumbClick.getCategory = () => {
    if($('body').hasClass('checkout-cart')) return 'Checkout - Basket';
    if($('body').hasClass('checkout-delivery')) return 'Checkout - Delivery';
    if($('body').hasClass('checkout-payment')) return 'Checkout - Payment';
    if($('body').hasClass('checkout-login')) return 'Checkout - Login';
    // TODO - no link to page
    if($('body').hasClass('checkout-register')) return 'Checkout - AccountCreation';
    return '';
  };
  breadcrumbClick.getLabel = $element => $element.data('at-name');
  tracker.addEvent(breadcrumbClick);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

};



// WEBPACK FOOTER //
// ./src/analytics/trackers/funnel/global-tracker.js